import { makeStyles } from '@material-ui/core/styles';
import blue from '@material-ui/core/colors/blue';
import blueGrey from '@material-ui/core/colors/blueGrey';
import grey from '@material-ui/core/colors/grey';

const useStyles = makeStyles((theme) => ({
  textColorGreen: {
    color: 'green',
  },
  textRedColor: {
    color: 'red',
  },
  addButton: {
    color: theme.palette.getContrastText(blue[500]),
    backgroundColor: blue[500],
    '&:hover': {
      backgroundColor: blue[700],
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: blue[500],
      },
    },
    alignSelf: 'flex-start',
    margin: 8,
  },
  submit: {
    color: theme.palette.getContrastText(blue[500]),
    backgroundColor: blue[500],
    '&:hover': {
      backgroundColor: blue[700],
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: blue[500],
      },
    },
    alignSelf: 'flex-start',
    marginTop: 10,
  },
  editButton: {
    color: theme.palette.getContrastText(grey[800]),
    marginLeft: 5,
    marginRight: 5,
    backgroundColor: grey[500],
    '&:hover': {
      backgroundColor: grey[700],
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: grey[500],
      },
    },
    alignSelf: 'flex-start',
  },
  viewButton: {
    marginRight: 5,
    marginLeft: 5,
    color: theme.palette.getContrastText(blueGrey[800]),
    backgroundColor: blueGrey[500],
    '&:hover': {
      backgroundColor: blueGrey[700],
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: blueGrey[300],
      },
    },
    alignSelf: 'flex-start',
  },
  form: {},
}));

export default useStyles;
